import { Box, styled } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { mobile } from '../../../utils/breakpoints'

export const LeftContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${({ theme }) => mobile(theme, { 'align-items': 'center' })}
`

export const LinkContainer = styled(Box)`
  display: flex;
  justify-content: flex-start;
  text-align: left;
  align-items: flex-start;
  ${({ theme }) => mobile(theme, { 'flex-direction': 'column', 'align-items': 'center' })}
`

export const LogoImage = styled('img')`
  max-height: 50px;
  margin-bottom: 20px;

  ${({ theme }) => mobile(theme, { maxHeight: '30px' })}
`

export const TextLink = styled(RouterLink)`
  padding: 0 10px;
  text-wrap-mode: nowrap;
  font-size: 18px;
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.branding.footerText};

  &:hover {
    color: ${({ theme }) => theme.palette.branding.footerTextHover};
  }

  ${({ theme }) =>
    mobile(theme, {
      'font-size': '16px',
    })}
`
